import AddRoundedIcon from "@mui/icons-material/AddRounded";
import TabPanel from "@mui/lab/TabPanel";
import { Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import AuthorizedBox from "@entrilia/shared/components/AuthorizedBox";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import PageTabs from "../../common/PageTabs";
import NewRunDialog from "./dialogs/new-run-dialog/NewRunDialog";
import WorkbookRunsContainer from "./runs/WorkbookRunsContainer";
import WorkbookTemplatesContainer from "./templates/WorkbookTemplatesContainer";

const tabValues = ["runs", "templates"] as const;

const tabPanelSx = { flex: 1, px: 3, pt: 2.5, width: "100%" };

const WorkbookRunnerPage = () => {
  usePageTitle("Workbooks");

  const navigate = useNavigate();

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  const [showNewRunDialog, setShowNewRunDialog] = useState(false);

  const handleRunStart = (runId: string) => {
    navigate(`run/${runId}`);
  };

  return (
    <>
      <GeneralPageHeader title="Workbooks" hideBorderLine>
        <AuthorizedBox permissions={["ManageReports"]}>
          <Button variant="contained" color="primary" onClick={() => setShowNewRunDialog(true)}>
            <AddRoundedIcon />
            New Run
          </Button>
        </AuthorizedBox>
      </GeneralPageHeader>
      <PageTabs tabs={tabValues} labels={["Runs", "Templates"]} value={selectedTab} onChange={onTabChange}>
        <TabPanel value="runs" sx={tabPanelSx}>
          <WorkbookRunsContainer />
        </TabPanel>
        <TabPanel value="templates" sx={tabPanelSx}>
          <WorkbookTemplatesContainer />
        </TabPanel>
      </PageTabs>
      <AuthorizedBox permissions={["ManageReports"]}>
        {showNewRunDialog && <NewRunDialog onClose={() => setShowNewRunDialog(false)} onStartRun={handleRunStart} />}
      </AuthorizedBox>
    </>
  );
};

export default WorkbookRunnerPage;
